/* INLOUVE — Bandeau défilant, sans dépendance */
if (!customElements.get('inlouve-marquee')) {
  customElements.define('inlouve-marquee', class extends HTMLElement {
    connectedCallback() {
      this.source = this.querySelector('[data-source]');
      this.track = this.querySelector('.inlouve-marquee__track');
      this.viewport = this.querySelector('.inlouve-marquee__viewport');
      this.button = this.querySelector('button');

      if (!this.source || !this.source.children.length) return;

      this.abort = new AbortController();
      const options = { signal: this.abort.signal };

      this.motion = matchMedia('(prefers-reduced-motion: reduce)');

      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.measure());
      };

      this.button.addEventListener('click', () => {
        const paused = this.toggleAttribute('data-paused');

        this.button.setAttribute(
          'aria-label',
          paused ? this.button.dataset.play : this.button.dataset.pause
        );

        this.button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
        this.schedule();
      }, options);

      this.addEventListener('shopify:block:select', () => {
        this.setAttribute('data-editing', '');
      }, options);

      this.addEventListener('shopify:block:deselect', () => {
        this.removeAttribute('data-editing');
        this.schedule();
      }, options);

      this.viewport.addEventListener('focusout', this.schedule, options);
      this.motion.addEventListener('change', this.schedule, options);

      this.observer = new ResizeObserver(this.schedule);
      this.observer.observe(this.viewport);
      this.observer.observe(this.source);

      document.fonts.ready.then(() => {
        if (this.isConnected) this.schedule();
      });

      this.schedule();
    }

    measure() {
      if (
        this.motion.matches ||
        this.hasAttribute('data-paused') ||
        this.hasAttribute('data-editing') ||
        this.viewport.matches(':focus-within')
      ) return;

      this.button.hidden = false;
      this.setAttribute('data-measuring', '');

      const width = this.source.getBoundingClientRect().width;
      const viewportWidth = this.viewport.clientWidth;

      this.removeAttribute('data-measuring');

      if (!width || !viewportWidth) return;

      const copies = Math.ceil(viewportWidth / width) + 1;
      const signature = `${width}:${copies}`;

      if (this.signature === signature) return;
      this.signature = signature;

      this.track.querySelectorAll('[data-copy]').forEach(copy => {
        copy.remove();
      });

      for (let i = 0; i < copies; i++) {
        const copy = this.source.cloneNode(true);

        copy.removeAttribute('data-source');
        copy.setAttribute('data-copy', '');
        copy.setAttribute('aria-hidden', 'true');

        copy.querySelectorAll('*').forEach(el => {
          el.removeAttribute('id');
          el.removeAttribute('data-shopify-editor-block');

          if (el.matches('a')) {
            el.setAttribute('tabindex', '-1');
          }
        });

        this.track.append(copy);
      }

      this.style.setProperty('--inlouve-distance', `${width}px`);
      this.style.setProperty(
        '--inlouve-duration',
        `${width / (Number(this.dataset.speed) || 30)}s`
      );

      this.setAttribute('data-ready', '');
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
      this.signature = null;
    }
  });
}